<template>
  <main>
    <div class="footer">
      <div class="desc">
        <div class="center">
          <div class="text">
            <p style="display: none;">推荐产品： 戴尔台式机电脑 成铭 戴尔 OptiPlex 7070 戴尔 Latitude 7400 DELL Precision 5540 戴尔显示器 戴尔 PowerEdge R740 EMC VMAX
              VxRail</p>
            <p style="display: none;">*所有买赠、补贴及秒杀活动需企业用户正式下单并完成支付后，持有效凭证与商城客服兑换所承诺福利，最终解释权归戴尔易安信企采网所有。</p>
            <p>* 向戴尔采购产品及服务的行为将受到如下相关条款与条件的约束。请点击链接 <a href="https://www.dell.com/zh-cn/lp/legal/terms-of-sale" target="_blank"><strong>https://www.dell.com/zh-cn/lp/legal/terms-of-sale</strong></a> 以获取适用于您的条款与条件。请仔细阅读相关条款与条件。如您不能通过链接获取您所适用的相关条款与条件，或希望在获取您所适用的相关的条款与条件上得到帮助，请联系戴尔的销售代表。</p>
          </div>
        </div>
      </div>
      <div class="copy">
        <div class="center">
          <div class="text">
            <p>戴尔仅在符合相关法律法规及<a href="https://www.dell.com/learn/cn/zh/cncorp1/policies-privacy" target="_blank"><strong>隐私声明</strong></a>和<a
                href="https://www.dell.com/learn/cn/zh/cncorp1/terms-of-sale?s=corp" target="_blank"><strong>销售条款</strong></a>下收集与使用客户访问信息。</p>
            <p>请浏览以下网站获得更多信息 <a href="https://www.dell.com/zh-cn/lp/legal/art-important-dell-detail-cn?c=cn&l=zh&s=corp&redirect=1" target="_blank">www.dell.com.cn/product_information</a></p>
            <p>增值电信业务许可证：京B2-20202426</p>
            <p>版权：©2018-2026 Dell Inc.版权所有 丨 <i class="beian">京ICP备11038982号-18</i></p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {
    this.query = this.$route.query;
  }
};
</script>

<style lang="scss" type="text/scss" scoped>
.footer {
  background: #1a56c6;
  color: #c7e2ff;

  .desc {
    padding-top: 20px;
    text-align: center;
    padding-bottom: 20px;

    .center {
      display: inline-block;
      width: 1200px;

      .text {
        text-align: left;
        font-size: 12px;
        line-height: 19px;

        strong {
          color: #fff;
        }

        a {
          color: #fff;

          strong {
            color: #fff;
          }
        }

        a:hover {
          text-decoration: underline !important;
        }

        .beian {
          padding-left: .3rem;
          background: url("../../assets/image/12.png") no-repeat left center;
          background-size: .2rem;
        }
      }
    }
  }

  .copy {
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
    box-shadow: -10px 0 10px 5px rgba(0, 0, 0, .1);

    .center {
      display: inline-block;
      width: 1200px;

      .text {
        text-align: left;
        font-size: 12px;
        line-height: 19px;

        a {
          color: #fff;
          padding: 0 5px;

          strong {
            color: #fff;
          }
        }

        a:hover {
          text-decoration: underline !important;
        }

        .beian {
          padding-left: .3rem;
          background: url("~@/assets/image/12.png") no-repeat left center;
          background-size: .2rem;
        }
      }
    }
  }
}
</style>

